const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  account: state => state.user.account.userId,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  allRoles: state => [ ...state.user.roles, ...state.user.currentProjectRoles ].filter(role => role.enabled === 1),
  projectRoles: state => state.user.currentProjectRoles.filter(role => role.enabled === 1),
  currentProject(state) {
    const { currentProject, projectList } = state.app;
    return projectList.find(f => f.id === currentProject);
  },
  isAWSUserMark: (state) => {
    return state.user.org?.specialTag === 'aws_market';
  }
};
export default getters;
